export async function fetchCurrentUser() {
  const res = await fetch('/api/auth/me', {
    credentials: 'include',
  })
  if (res.status === 401) {
    return null
  }
  if (!res.ok) {
    let detail = `加载登录态失败：${res.status}`
    try {
      const body = await res.json()
      if (body.detail) detail = body.detail
    } catch {
      // ignore
    }
    throw new Error(detail)
  }
  const body = await res.json()
  return body.user
}

export async function logout() {
  const res = await fetch('/api/auth/logout', {
    method: 'POST',
    credentials: 'include',
  })
  if (!res.ok) {
    let detail = '退出失败'
    try {
      const body = await res.json()
      if (body.detail) detail = body.detail
    } catch {
      // ignore
    }
    throw new Error(detail)
  }
}

export function buildLoginUrl(nextPath = '/account') {
  const safeNext = nextPath.startsWith('/') ? nextPath : '/account'
  return `/login?next=${encodeURIComponent(safeNext)}`
}

export function resolveNextPath(defaultPath = '/account') {
  const next = new URLSearchParams(window.location.search).get('next')
  if (next && next.startsWith('/')) {
    return next
  }
  return defaultPath
}
